import { revokeTrackingConsent } from 'utilities/tracking-consent'

type CreateClientTrackingConsentMutate = (options: {
  variables: { clientId: number | string; source: string }
}) => Promise<{
  data?: { createClientTrackingConsent?: boolean | null } | null
}>

// The single owner of record-after-grant semantics, shared by every consent
// moment. The client-side grant already happened when this runs; any outcome
// that leaves the server without a consent record must revoke the client
// state so browser and DB never diverge:
//   - no client id to record against → revoke
//   - server refused (returns false, e.g. Sec-GPC) → revoke
//   - mutation rejected (network/server error) → revoke
// Never blocks the funnel — callers fire and forget.
export const recordTrackingConsent = (
  mutate: CreateClientTrackingConsentMutate,
  clientId: number | string | null | undefined,
  source: string
): void => {
  if (!clientId) {
    revokeTrackingConsent()
    return
  }

  mutate({ variables: { clientId, source } })
    .then(result => {
      if (result?.data?.createClientTrackingConsent === false) {
        revokeTrackingConsent()
      }
    })
    .catch(revokeTrackingConsent)
}
